type RequestStaffMerchantGroupPortalLink = {
  merchantGroupId: string
}

type RequestStaffMerchantGroupPortalLinkResponse = {
  portalLink: string
}

export const requestStaffMerchantGroupPortalLink = async (
  payload: RequestStaffMerchantGroupPortalLink
) => {
  const { body } =
    await api.post<RequestStaffMerchantGroupPortalLinkResponse>(
      "/merchant-groups/staff/portal-link/",
      {
        body: payload,
      }
    )
  return body
}
